import type { AnalyticsEvent, AnalyticsParams } from '../events';

/** Base class for tracking destinations. */
export abstract class TrackingDestination {
  deliver(event: AnalyticsEvent, payload: AnalyticsParams): void {
    if (!this.isEnabled()) return;
    this.send(event, payload);
  }

  protected abstract isEnabled(): boolean;

  protected abstract send(
    event: AnalyticsEvent,
    payload: AnalyticsParams,
  ): void;
}
